import { getRecentDoctors } from 'Redux/modules/doctor/actions';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useRecentDoctors = () => {
  const dispatch = useDispatch();

  const {
    doctors: { recents },
  } = useSelector(state => state);

  const getListRecentDoctor = useCallback(
    async doctorId => {
      await dispatch(getRecentDoctors(doctorId));
    },
    [dispatch],
  );

  return {
    getRecentDoctors: getListRecentDoctor,
    recentDoctors: recents,
  };
};

export default useRecentDoctors;
